import { useCallback } from "react";
import { FormInstance } from "antd";

export default function useSubmitOnEnter(form: FormInstance, enabled: boolean = true) {

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (!enabled) return;

    if (e.key !== "Enter") return;

    const target = e.target as HTMLElement;

    if (target.tagName === "TEXTAREA") return;

    e.preventDefault();
    form.submit();

  }, [form, enabled]);

  return handleKeyDown;
}